import React from 'react';
import TitleCard from '../components/TitleCard/TitleCard';
import RegisterForm from '../components/Forms/RegisterForm/RegisterForm';

const Register: React.FC = (props: any) => {
  return (
    <>
      <TitleCard />
      <RegisterForm {...props} />
    </>
  );
};

export default Register;
